module.exports = "../fonts/n-a.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/n-a.ttf
// module id = wKCN
// module chunks = 1